module.exports = __webpack_public_path__ + "img/wallet_02_multi_2.6b902ddf.png";